module.exports = __webpack_public_path__ + "static/media/sherpaCup.810dccda.svg";